import { displayValue } from '../../hooks/export';
import { useSingleUserTransaction } from './UserDetailapi';
import PropTypes from 'prop-types';


function UserManage({ id }) {

    const singleusertransaction = useSingleUserTransaction({ userId: id });

    return (
        <div className="row gy-4">

            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                <div className="ad_pg_cd_cnt"><h4>TRON</h4>
                    <div className="ad_pg_cd" style={{ backgroundColor: "#4F5CFB" }}>
                        <div className="ad_pg_cd_rcnt tp">
                            <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                <div className="col-auto ad_pg_cd_c">
                                    <div className="ad_pg_cd_lb">TRX Deposit</div>
                                    <div className="ad_pg_cd_vl">
                                        <h6>{
                                            displayValue(singleusertransaction?.data?.data?.mergedData?.tron?.trx?.deposit, 6)
                                        }
                                        </h6>
                                    </div>
                                </div>
                                <div className="col-auto ad_pg_cd_c">
                                    <div className="ad_pg_cd_lb">TRX Withdraw</div>
                                    <div className="ad_pg_cd_vl">
                                        <h6>
                                            {
                                                displayValue(singleusertransaction?.data?.data?.mergedData?.tron?.trx?.withdraw, 6)
                                            }
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="ad_pg_cd_rcnt bm">
                            <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                <div className="col-auto ad_pg_cd_c">
                                    <div className="ad_pg_cd_lb">USDT Deposit</div>
                                    <div className="ad_pg_cd_vl"><h6>

                                        {
                                            displayValue(singleusertransaction?.data?.data?.mergedData?.tron?.usdt?.deposit, 6)
                                        }
                                    </h6></div>
                                </div>
                                <div className="col-auto ad_pg_cd_c">
                                    <div className="ad_pg_cd_lb">USDT Withdraw</div>
                                    <div className="ad_pg_cd_vl">
                                        <h6>
                                            {
                                                displayValue(singleusertransaction?.data?.data?.mergedData?.tron?.usdt?.withdraw, 6)
                                            }
                                        </h6></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                <div className="ad_pg_cd_cnt"><h4>Polygon</h4>
                    <div className="ad_pg_cd" style={{ backgroundColor: "rgb(247, 102, 70)" }}>
                        <div className="ad_pg_cd_rcnt tp">
                            <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                <div className="col-auto ad_pg_cd_c">
                                    <div className="ad_pg_cd_lb">Pol Deposit </div>
                                    <div className="ad_pg_cd_vl">
                                        <h6>
                                            {
                                                displayValue(singleusertransaction?.data?.data?.mergedData?.polygon?.pol?.deposit, 6)
                                            }
                                        </h6> </div>
                                </div>
                                <div className="col-auto ad_pg_cd_c">
                                    <div className="ad_pg_cd_lb">Pol Withdraw </div>
                                    <div className="ad_pg_cd_vl">
                                        <h6>

                                            {
                                                displayValue(singleusertransaction?.data?.data?.mergedData?.polygon?.pol?.withdraw, 6)
                                            }
                                        </h6> </div>
                                </div>
                            </div>
                        </div>
                        <div className="ad_pg_cd_rcnt bm">
                            <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                <div className="col-auto ad_pg_cd_c">
                                    <div className="ad_pg_cd_lb">USDT Deposit</div>
                                    <div className="ad_pg_cd_vl"><h6>

                                        {
                                            displayValue(singleusertransaction?.data?.data?.mergedData?.polygon?.usdt?.deposit, 6)
                                        }
                                    </h6></div>
                                </div>
                                <div className="col-auto ad_pg_cd_c">
                                    <div className="ad_pg_cd_lb">USDT Withdraw</div>
                                    <div className="ad_pg_cd_vl">
                                        <h6>

                                            {
                                                displayValue(singleusertransaction?.data?.data?.mergedData?.polygon?.usdt?.withdraw, 6)
                                            }
                                        </h6></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                <div className="ad_pg_cd_cnt"><h4>BNB</h4>
                    <div className="ad_pg_cd" style={{ backgroundColor: "rgb(129, 106, 31)" }}>
                        <div className="ad_pg_cd_rcnt tp">
                            <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                <div className="col-auto ad_pg_cd_c">
                                    <div className="ad_pg_cd_lb">BNB Deposit</div>
                                    <div className="ad_pg_cd_vl">
                                        <h6>

                                            {
                                                displayValue(singleusertransaction?.data?.data?.mergedData?.bnb?.bnb?.deposit, 6)
                                            }
                                        </h6> </div>
                                </div>
                                <div className="col-auto ad_pg_cd_c">
                                    <div className="ad_pg_cd_lb">BNB Withdraw </div>
                                    <div className="ad_pg_cd_vl">
                                        <h6>

                                            {
                                                displayValue(singleusertransaction?.data?.data?.mergedData?.bnb?.bnb?.withdraw, 6)
                                            }
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="ad_pg_cd_rcnt bm">
                            <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                <div className="col-auto ad_pg_cd_c">
                                    <div className="ad_pg_cd_lb">USDT Deposit</div>
                                    <div className="ad_pg_cd_vl">
                                        <h6>

                                            {
                                                displayValue(singleusertransaction?.data?.data?.mergedData?.bnb?.usdt?.deposit, 6)
                                            }
                                        </h6>
                                    </div>
                                </div>
                                <div className="col-auto ad_pg_cd_c">
                                    <div className="ad_pg_cd_lb">USDT Withdraw</div>
                                    <div className="ad_pg_cd_vl">
                                        <h6>

                                            {
                                                displayValue(singleusertransaction?.data?.data?.mergedData?.bnb?.usdt?.withdraw, 6)
                                            }
                                        </h6></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                <div className="ad_pg_cd_cnt"><h4>ETH</h4>
                    <div className="ad_pg_cd" style={{ backgroundColor: "rgb(110 23 23)" }}>
                        <div className="ad_pg_cd_rcnt tp">
                            <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                <div className="col-auto ad_pg_cd_c">
                                    <div className="ad_pg_cd_lb">ETH Deposit</div>
                                    <div className="ad_pg_cd_vl">
                                        <h6>

                                            {
                                                displayValue(singleusertransaction?.data?.data?.mergedData?.eth?.eth?.deposit, 6)
                                            }
                                        </h6>
                                    </div>
                                </div>
                                <div className="col-auto ad_pg_cd_c">
                                    <div className="ad_pg_cd_lb"> ETH Withdraw</div>
                                    <div className="ad_pg_cd_vl">
                                        <h6>

                                            {
                                                displayValue(singleusertransaction?.data?.data?.mergedData?.eth?.eth?.withdraw, 6)
                                            }
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="ad_pg_cd_rcnt bm">
                            <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                <div className="col-auto ad_pg_cd_c">
                                    <div className="ad_pg_cd_lb">USDT Deposit</div>
                                    <div className="ad_pg_cd_vl">
                                        <h6>

                                            {
                                                displayValue(singleusertransaction?.data?.data?.mergedData?.eth?.usdt?.deposit, 6)
                                            }
                                        </h6>
                                    </div>
                                </div>
                                <div className="col-auto ad_pg_cd_c">
                                    <div className="ad_pg_cd_lb">USDT Withdraw</div>
                                    <div className="ad_pg_cd_vl">
                                        <h6>

                                            {
                                                displayValue(singleusertransaction?.data?.data?.mergedData?.eth?.usdt?.withdraw, 6)
                                            }
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                <div className="ad_pg_cd_cnt"><h4>SOL</h4>
                    <div className="ad_pg_cd" style={{ backgroundColor: "rgb(24, 143, 127)" }}>
                        <div className="ad_pg_cd_rcnt tp">
                            <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                <div className="col-auto ad_pg_cd_c">
                                    <div className="ad_pg_cd_lb">SOL Deposit</div>
                                    <div className="ad_pg_cd_vl">
                                        <h6>

                                            {
                                                displayValue(singleusertransaction?.data?.data?.mergedData?.sol?.sol?.deposit, 6)
                                            }
                                        </h6>
                                    </div>
                                </div>
                                <div className="col-auto ad_pg_cd_c">
                                    <div className="ad_pg_cd_lb">SOL Withdraw</div>
                                    <div className="ad_pg_cd_vl">
                                        <h6>

                                            {
                                                displayValue(singleusertransaction?.data?.data?.mergedData?.sol?.sol?.withdraw, 6)
                                            }
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="ad_pg_cd_rcnt bm">
                            <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                <div className="col-auto ad_pg_cd_c">
                                    <div className="ad_pg_cd_lb">USDT Deposit</div>
                                    <div className="ad_pg_cd_vl">
                                        <h6>

                                            {
                                                displayValue(singleusertransaction?.data?.data?.mergedData?.sol?.usdt?.deposit, 6)
                                            }
                                        </h6>
                                    </div>
                                </div>
                                <div className="col-auto ad_pg_cd_c">
                                    <div className="ad_pg_cd_lb">USDT Withdraw</div>
                                    <div className="ad_pg_cd_vl">
                                        <h6>

                                            {
                                                displayValue(singleusertransaction?.data?.data?.mergedData?.sol?.usdt?.withdraw, 6)
                                            }
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                <div className="ad_pg_cd_cnt"><h4>Polygon ROU</h4>
                    <div className="ad_pg_cd" style={{ backgroundColor: "rgb(11, 66, 36)" }}>
                        <div className="ad_pg_cd_rcnt tp">
                            <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                <div className="col-auto ad_pg_cd_c">
                                    <div className="ad_pg_cd_lb">ROU Deposit</div>
                                    <div className="ad_pg_cd_vl">
                                        <h6>

                                            {
                                                displayValue(singleusertransaction?.data?.data?.mergedData?.polygon?.rou?.deposit, 6)
                                            }
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="ad_pg_cd_rcnt bm">
                            <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                <div className="col-auto ad_pg_cd_c">
                                    <div className="ad_pg_cd_lb">ROU Withdraw</div>
                                    <div className="ad_pg_cd_vl">
                                        <h6>

                                            {
                                                displayValue(singleusertransaction?.data?.data?.mergedData?.polygon?.rou?.withdraw, 6)
                                            }
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>






            {
                singleusertransaction?.data?.data?.mergedData?.card?.cardBalance?.balance == "This cardHolder not found" ? "" :

                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                        <div className="ad_pg_cd_cnt"><h4>Card Balance</h4>
                            <div className="ad_pg_cd" style={{ backgroundColor: "rgb(91, 148, 194)" }}>
                                <div className="ad_pg_cd_rcnt tp">
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb">Balance</div>
                                            <div className="ad_pg_cd_vl">
                                                <h6>
                                                    {
                                                        Number.isInteger(singleusertransaction?.data?.data?.mergedData?.card?.cardBalance?.balance)
                                                            ? singleusertransaction?.data?.data?.mergedData?.card?.cardBalance?.balance
                                                            : 0
                                                    } $
                                                </h6>
                                            </div>
                                        </div>
                                        <div className="col-auto ad_pg_cd_c">

                                        </div>
                                    </div>
                                </div>
                                <div className="ad_pg_cd_rcnt bm">
                                    <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                        <div className="col-auto ad_pg_cd_c">
                                            <div className="ad_pg_cd_lb" ></div>
                                            <div className="ad_pg_cd_vl">
                                                <h6>

                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

            }


        </div >
    );
}
UserManage.propTypes = {
    id: PropTypes.any.isRequired,

};


export default UserManage;


